import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const ShopPolicyWithDefault_Fragment = graphqlShopifyStorefront(`
  fragment ShopPolicyWithDefault on ShopPolicyWithDefault {
    body
    handle
    id
    title
    url
  }
`);
